import '../../datosPersona/_datosPersonaTurno.scss';
import profileImage from '../../../images/imagen-card1.png';
import { RaceBy } from '@uiball/loaders';
import { BsCheckCircleFill } from 'react-icons/bs';

export default function ModalVerRespuestas({ resultado, loading, ver_modal, setModal }) {
    if (!ver_modal) return null;

    let respuestas = [];
    try { respuestas = JSON.parse(resultado?.respuestas || '[]'); } catch (_) {}

    const formatFecha = (fecha) => {
        if (!fecha) return '-';
        return new Date(fecha).toLocaleString('es-AR', { dateStyle: 'short', timeStyle: 'short' });
    };

    const formatSoloFecha = (fecha) => {
        if (!fecha) return '-';
        return new Date(fecha).toLocaleDateString('es-AR');
    };

    return (
        <div className="modal show d-block" tabIndex="-1" aria-modal="true">
            <div className="modal-dialog modal-xl">
                <div className="modal-content">
                    <div className="modal-header">
                        <h6>Resultado de encuesta</h6>
                        <button type="button" className="btn-close" onClick={() => setModal(false)} aria-label="Close" />
                    </div>

                    <div className="modal-body">
                        {loading && (
                            <div className="d-flex justify-content-center py-5">
                                <RaceBy size={180} lineWeight={12} speed={1.4} color="black" />
                            </div>
                        )}

                        {!loading && resultado && (
                            <div className="h-100 container d-flex flex-column p-0" id="show">

                                {/* Colaborador */}
                                <div className="col-12 d-flex">
                                    <div className="col-3 d-flex justify-content-center align-items-center">
                                        <img src={profileImage} alt="imagen perfil" className="img-fluid" />
                                    </div>
                                    <div className="col-9">
                                        <h3 className="titlegray">
                                            {resultado.persona_nombre} {resultado.persona_apellido}
                                        </h3>
                                        <div className="mt-4 container__main__datos">
                                            <div className="container__historial__card">
                                                <div className="row">
                                                    <div className="col-md-6">
                                                        {resultado.turno_id && resultado.motivo_turno_abreviacion && (
                                                            <div>
                                                                <h6>#{resultado.motivo_turno_abreviacion} - {resultado.turno_id}</h6>
                                                            </div>
                                                        )}
                                                        <div>
                                                            <p><b>Encuesta:</b> <span>{resultado.formulario_nombre || '-'}</span></p>
                                                        </div>
                                                        <div>
                                                            <p><b>Fecha respuesta:</b> <span>{formatFecha(resultado.fecha_respuesta)}</span></p>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6">
                                                        {resultado.persona_dni && (
                                                            <div>
                                                                <p><b>DNI:</b> <span>{resultado.persona_dni}</span></p>
                                                            </div>
                                                        )}
                                                        {resultado.persona_email && (
                                                            <div>
                                                                <p><b>Email:</b> <span>{resultado.persona_email}</span></p>
                                                            </div>
                                                        )}
                                                        {resultado.persona_legajo && (
                                                            <div>
                                                                <p><b>Legajo:</b> <span>{resultado.persona_legajo}</span></p>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Datos del turno */}
                                {resultado.turno_id && (
                                    <div className="col-12 container__main__datos">
                                        <div className="container__historial__card bordersCustom my-4 py-4">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div>
                                                        <p><b>Sucursal:</b> <span>{resultado.sucursal_nombre || '-'}</span></p>
                                                    </div>
                                                    <div>
                                                        <p><b>Fecha:</b> <span>{formatSoloFecha(resultado.turno_fecha)}</span></p>
                                                    </div>
                                                    <div>
                                                        <p><b>Hora:</b> <span>{resultado.turno_hora || '-'}</span></p>
                                                    </div>
                                                    <div>
                                                        <p><b>Motivo:</b> <span>{resultado.motivo_turno_nombre || '-'}</span></p>
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div>
                                                        <p><b>Estado:</b> <span>{resultado.estado_turno || '-'}</span></p>
                                                    </div>
                                                    <div>
                                                        <p><b>Tipo:</b> <span>{resultado.tipo_turno || '-'}</span></p>
                                                    </div>
                                                    {resultado.turno_empresa && (
                                                        <div>
                                                            <p><b>Empresa:</b> <span>{resultado.turno_empresa}</span></p>
                                                        </div>
                                                    )}
                                                    {resultado.turno_fecha_creacion && (
                                                        <div>
                                                            <p><b>Creado:</b> <span>{formatFecha(resultado.turno_fecha_creacion)}</span></p>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                            {resultado.turno_observacion && (
                                                <div className="row mt-2">
                                                    <div className="col-12">
                                                        <p><b>Observación:</b> <span>{resultado.turno_observacion}</span></p>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                )}

                                {/* Timestamps atención / finalización */}
                                {(resultado.fecha_atencion || resultado.fecha_finalizacion) && (
                                    <div className="col-12 container__main__datos">
                                        <div className="container__historial__card my-3 py-2">
                                            <div className="row">
                                                {resultado.fecha_atencion && (
                                                    <div className="col-md-6">
                                                        <p><b>Atendido:</b> <span>{formatFecha(resultado.fecha_atencion)}</span></p>
                                                    </div>
                                                )}
                                                {resultado.fecha_finalizacion && (
                                                    <div className="col-md-6">
                                                        <p><b>Finalizado:</b> <span>{formatFecha(resultado.fecha_finalizacion)}</span></p>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {/* Operadores */}
                                {(resultado.operador_nombre || resultado.creador_nombre) && (
                                    <div className="col-12 container__main__datos">
                                        <div className="container__historial__card my-3 py-2">
                                            {resultado.operador_nombre && (
                                                <div>
                                                    <p><b>Atendido por:</b> <span>{resultado.operador_nombre} {resultado.operador_apellido || ''}</span></p>
                                                </div>
                                            )}
                                            {resultado.creador_nombre && (
                                                <div>
                                                    <p><b>Creado por:</b> <span>{resultado.creador_nombre} {resultado.creador_apellido || ''}</span></p>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                )}

                                {/* Respuestas */}
                                <div className="col-12 container__main__datos">
                                    <div className="container__historial__card my-3 py-2">
                                        <h5 className="text-center mb-3"><b>Respuestas</b></h5>
                                        {respuestas.length > 0 ? (
                                            respuestas.map((r, i) => (
                                                <div key={i} className="d-flex align-items-center gap-2 py-2 border-bottom">
                                                    <BsCheckCircleFill style={{ color: 'var(--color-green-two)', flexShrink: 0 }} />
                                                    <div>
                                                        <small className="text-muted d-block">Pregunta {i + 1}</small>
                                                        <span className="fw-semibold">{r.valor}</span>
                                                    </div>
                                                </div>
                                            ))
                                        ) : (
                                            <p className="text-muted mb-0 text-center">Sin respuestas registradas.</p>
                                        )}
                                    </div>
                                </div>

                            </div>
                        )}
                    </div>

                    <div className="modal-footer">
                        <button className="btn btn-secondary" onClick={() => setModal(false)}>Cerrar</button>
                    </div>
                </div>
            </div>
        </div>
    );
}
